module.exports = __webpack_public_path__ + "static/media/lid.318a122e.svg";